import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import CI0401C from '../../components/CI/CI0401/index';
function mapDispatchToProps(_ref) {
  var ci0401Info = _ref.ci0401Info,
    loading = _ref.loading;
  return {
    ci0401Info: ci0401Info,
    loading: loading
  };
}
var CI0401R = _Form.create()(CI0401C);
export default connect(mapDispatchToProps)(CI0401R);